import script from "./MatrixTableWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./MatrixTableWidget.vue?vue&type=script&setup=true&lang=js"

import "./MatrixTableWidget.vue?vue&type=style&index=0&id=7ef96a26&scoped=true&lang=css"

import exportComponent from "../../../SherpaCRM/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ef96a26"]])

export default __exports__